import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "common";
import { Observable } from "rxjs";
import { CreateFacilityData, FacilityDetailsData, FacilityEditData, FacilityQueryParams, FacilityQueryResult } from "../domain/models/facility.model";

@Injectable({
  providedIn: "root",
})
export class FacilitiesRemote {
  private readonly facilitiesUrl: string;

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
  ) {
    this.facilitiesUrl = `${this.configService.environment.facilities.url}/facilities`;
  }
  query(params: FacilityQueryParams): Observable<FacilityQueryResult> {
    return this.http.get<FacilityQueryResult>(`${this.facilitiesUrl}`, {
      headers: this.configService.environment.cache.longLived,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      params: <any>params,
    });
  }

  get(id: number): Observable<FacilityDetailsData> {
    return this.http.get<FacilityDetailsData>(`${this.facilitiesUrl}/${id}`);
  }

  create(facility: CreateFacilityData): Observable<FacilityDetailsData> {
    return this.http.post<FacilityDetailsData>(`${this.facilitiesUrl}`, facility);
  }

  patch(id: number, facility: FacilityEditData): Observable<FacilityDetailsData> {
    return this.http.patch<FacilityDetailsData>(`${this.facilitiesUrl}/${id}`, facility);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.facilitiesUrl}/${id}`);
  }
}
